export var InvoiceEventType;
(function (InvoiceEventType) {
    /** When PAIDNICE first inserted the invoice, NOT the issue date */
    InvoiceEventType["IMPORTED"] = "imported";
    /** When any status changes to `paid` anytime as long as the prior status was not paid */
    InvoiceEventType["PAID"] = "paid";
    /** When `paid` changes to `authorised` */
    InvoiceEventType["PAYMENT_REVERSED"] = "payment_reversed";
    /** When any status changes to void for first time */
    InvoiceEventType["VOIDED"] = "voided";
    /** When the due date changes */
    InvoiceEventType["DUE_DATE_CHANGED"] = "due_date_changed";
    /** When the invoice is frozen automatically */
    InvoiceEventType["AUTO_FROZEN"] = "auto_frozen";
    /** When the invoice is frozen manually */
    InvoiceEventType["MANUAL_FROZEN"] = "manual_frozen";
    /** When the invoice is unfrozen manually */
    InvoiceEventType["UNFROZEN"] = "unfrozen";
    /** When an expected payment date is saved by the user */
    InvoiceEventType["EXPECTED_PAYMENT_DATE_CHANGED"] = "expected_payment_date_changed";
    /** When the line items change */
    InvoiceEventType["LINE_ITEMS_CHANGED"] = "line_items_changed";
    /** When total amount changes */
    InvoiceEventType["TOTAL_AMOUNT_CHANGED"] = "total_amount_changed";
    /** When a customer says they have paid via comms; claimed date + source message stored in metadata */
    InvoiceEventType["CUSTOMER_CLAIMED_PAYMENT"] = "customer_claimed_payment";
    /** A payment promise was recorded against the invoice */
    InvoiceEventType["PROMISE_MADE"] = "promise_made";
    /** The open payment promise was paid in time */
    InvoiceEventType["PROMISE_KEPT"] = "promise_kept";
    /** The open payment promise was not paid by the promised date (+ grace) */
    InvoiceEventType["PROMISE_BROKEN"] = "promise_broken";
    /** The open payment promise was cancelled by a user */
    InvoiceEventType["PROMISE_CANCELLED"] = "promise_cancelled";
    /** A query was opened on the invoice */
    InvoiceEventType["QUERY_OPENED"] = "query_opened";
    /** The open query was resolved (manually, or automatically when paid or voided) */
    InvoiceEventType["QUERY_RESOLVED"] = "query_resolved";
    /** The open query passed its due date without being resolved */
    InvoiceEventType["QUERY_OVERDUE"] = "query_overdue";
})(InvoiceEventType || (InvoiceEventType = {}));
//# sourceMappingURL=invoiceEvent.js.map